import { BarChart } from "@mui/x-charts/BarChart";
import { Stack, useTheme } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";


const RevenueVsExpensesChart = ({ revenueTotalByMonth = [], expensesTotalByMonth = [] }) => {
    const theme = useTheme();
    const { bt } = useBizTypeTranslation();
    const [data, setData] = useState([])

    useEffect(() => {
        setData({
            months: monthLabels ? [...monthLabels].reverse() : [],
            revenue: revenueTotalByMonth ? [...revenueTotalByMonth].reverse() : [],
            expenses: expensesTotalByMonth ? [...expensesTotalByMonth].reverse() : [],
        })
    }, [revenueTotalByMonth, expensesTotalByMonth]);

    const monthLabels = [
        bt("JANUARY"),
        bt("FEBRUARY"),
        bt("MARCH"),
        bt("APRIL"),
        bt("MAY"),
        bt("JUNE"),
        bt("JULY"),
        bt("AUGUST"),
        bt("SEPTEMBER"),
        bt("OCTOBER"),
        bt("NOVEMBER"),
        bt("DECEMBER"),
    ];

    if (data?.length === 0) return

    return (
        <Stack width="100%" padding={{ xs: 0, md: 1 }}>
            <BarChart
                height={300}
                margin={{ top: 20, right: 10, bottom: 30, left: 45 }}
                slotProps={{
                    legend: { hidden: true },
                }}
                xAxis={[
                    {
                        scaleType: "band",
                        data: data?.months,
                        categoryGapRatio: 0.3,
                        barGapRatio: 0.1,
                    },
                ]}
                yAxis={[
                    {
                        width: 45,
                    },
                ]}
                series={[
                    {
                        data: data?.revenue,
                        label: bt("REVENUE"),
                        color: theme.palette.success.main
                    },
                    {
                        data: data?.expenses,
                        label: bt("EXPENSES"),
                        color: theme.palette.error.text
                    },
                ]}
            />
        </Stack>
    );
}

export default RevenueVsExpensesChart